export enum Color {
    RED = "#ee6666",
    ORANGE = "#ffd485",
    YELLOW = "#fff957",
    GREEN = "#bdecb6",
    WHITE = "#fff"
}